import BookIcon from "@redotech/redo-icons/book-open-01.svg";
import FileIcon from "@redotech/redo-icons/file-02.svg";
import FlipBackwardIcon from "@redotech/redo-icons/flip-backward.svg";
import MessageIcon from "@redotech/redo-icons/message-text-square-02.svg";
import PackageIcon from "@redotech/redo-icons/package.svg";
import UsersIcon from "@redotech/redo-icons/users-02.svg";
import type { ComponentType } from "react";
import type { KeyboardShortcut } from "../../keyboard-shortcuts/keyboard-shortcut";
import { globalActionIds, type GlobalActionId } from "./action-ids";

/**
 * Static action definition - UI metadata only.
 */
export interface StaticGlobalActionDefinition {
  id: GlobalActionId;
  title: string;
  description: string;
  shortcut?: KeyboardShortcut;
  Icon?: ComponentType<{ className?: string }>;
  category?: string;
}

/**
 * All global action definitions with static metadata.
 */
export const globalActionDefinitions: Record<
  GlobalActionId,
  StaticGlobalActionDefinition
> = {
  [globalActionIds.searchOrders]: {
    id: globalActionIds.searchOrders,
    title: "Orders",
    description: "Search for orders",
    Icon: PackageIcon,
    category: "Search",
  },
  [globalActionIds.searchReturns]: {
    id: globalActionIds.searchReturns,
    title: "Returns",
    description: "Search for returns",
    Icon: FlipBackwardIcon,
    category: "Search",
  },
  [globalActionIds.searchCustomers]: {
    id: globalActionIds.searchCustomers,
    title: "Customers",
    description: "Search for customers",
    Icon: UsersIcon,
    category: "Search",
  },
  [globalActionIds.searchConversations]: {
    id: globalActionIds.searchConversations,
    title: "Conversations",
    description: "Search for conversations",
    Icon: MessageIcon,
    category: "Search",
  },
  [globalActionIds.searchPages]: {
    id: globalActionIds.searchPages,
    title: "Pages",
    description: "Navigate to pages",
    Icon: FileIcon,
    category: "Search",
  },
  [globalActionIds.searchHelpArticles]: {
    id: globalActionIds.searchHelpArticles,
    title: "Help articles",
    description: "Search help articles",
    Icon: BookIcon,
    category: "Search",
  },
};

/**
 * Get a static global action definition by ID.
 */
export function getStaticGlobalActionDefinition(
  id: GlobalActionId,
): StaticGlobalActionDefinition {
  return globalActionDefinitions[id];
}
